function createDefaultItemComponent(param) {
    var createElement = param.createElement, Fragment = param.Fragment;
    return function DefaultItem(userProps) {
        return /*#__PURE__*/ createElement(Fragment, null, JSON.stringify(userProps.item, null, 2));
    };
}

export { createDefaultItemComponent };
